import { BellIcon } from "@heroicons/react/24/outline";
export default function TopBar({ title, actions }) {

  return (
    <header className="h-14 bg-white border-b border-gray-200 px-6 flex items-center justify-between shrink-0">
      <h1 className="text-base font-semibold text-gray-900 border-l-2 border-bh-500 pl-3">{title}</h1>
      <div className="flex items-center gap-3">
        {actions}
        <button className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500 transition-colors">
          <BellIcon className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
